export const buildWwwHeartbeatOrEmpty = (data) => {
    if (!data) {
        return {
            _id: '',
            _type: 'heartbeatData',
            _createdAt: '',
            _updatedAt: '',
            _rev: '',
            country: '',
            countryCode: '',
            regionName: '',
            region: '',
            city: '',
            currency: '',
            csrfToken: '',
            ip: '',
            now: Date.now(),
            lastFetched: undefined,
        };
    }
    return {
        _id: data._id || '',
        _type: 'heartbeatData',
        _createdAt: data._createdAt || '',
        _updatedAt: data._updatedAt || '',
        _rev: data._rev || '',
        country: data.country || '',
        countryCode: data.countryCode || '',
        regionName: data.regionName || '',
        region: data.region || '',
        city: data.city || '',
        currency: data.currency || '',
        csrfToken: data.csrfToken || '',
        ip: data.ip || '',
        now: data.now || Date.now(),
        lastFetched: data.lastFetched || undefined,
    };
};
